module.exports = __webpack_public_path__ + "media/images/download-768f861aba051f7db95029b688c8a255.svg";